<template>
    <div class="modal fade" id="settlementReceiptView">
      <div class="modal-dialog modal-default">
        <div class="modal-content">
          <div class="modal-header bg-aqua">
              <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              <button @click="printSettlementReceiptView()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
          </div>
          <div class="modal-body" id="printSettlementReceiptView">
              <div class="row printing" v-if="seeRecordSettlement">
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <p class="text-bold text-center" v-if="$store.state.settingRecord">{{$store.state.settingRecord.companyName}} <br> Settlement Details</p> 
                      <table class="table table-condensed center">
                        <thead>
                          <tr v-if="seeRecordSettlement.branch">
                          <td>Branch</td>
                          <td>{{seeRecordSettlement.branch.name}}</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="seeRecordSettlement.created_by">
                            <td>Created By</td>
                            <td>{{seeRecordSettlement.created_by.name}} <span v-if="seeRecordSettlement.created_by.code">( {{seeRecordSettlement.created_by.code}} )</span></td>
                          </tr>
                          <tr>
                            <td>Date</td>
                            <td>{{seeRecordSettlement.sattlementDate | myDate}}</td>
                          </tr>
                          <tr v-if ="seeRecordSettlement.type">
                            <td>Type</td>
                            <td v-if="seeRecordSettlement.type === 'panulty'">penalty</td>
                            <td v-else>{{seeRecordSettlement.type}}</td>
                          </tr>
                          <tr v-if="seeRecordSettlement.member_loan_plan">
                            <td>Loan Id</td>
                            <td>{{seeRecordSettlement.member_loan_plan.applicationNo}}</td>
                          </tr>
                          <tr v-if="seeRecordSettlement.member">
                            <td>Member</td>
                            <td>{{seeRecordSettlement.member.name}} <span v-if="seeRecordSettlement.member.code">( {{seeRecordSettlement.member.code}} )</span></td>
                          </tr>
                          <tr v-if="seeRecordSettlement.member">
                            <td>Mobile</td>
                            <td>{{seeRecordSettlement.member.mobile}}</td>
                          </tr>
                          <tr>
                            <td>Total Installment Due</td>
                            <td>{{seeRecordSettlement.totalInstallmentDue}}</td>
                          </tr>
                          <tr>
                            <td>Total Installment Paid</td>
                            <td>{{seeRecordSettlement.totalInstallmentPaid}}</td>
                          </tr>
                          <tr>
                            <td>Loan Amount</td>
                            <td>{{seeRecordSettlement.planAmount}}</td>
                          </tr>
                          <tr>
                            <td>Due Amount</td>
                            <td>{{seeRecordSettlement.totalAmountDue}}</td>
                          </tr>
                          <tr>
                            <td>Due Amount Without Interest</td>
                            <td>{{seeRecordSettlement.totalAmountDueWithoutInterest}}</td>
                          </tr>
                          <tr>
                            <td>Total Amount Paid</td>
                            <td>{{seeRecordSettlement.totalAmountPaid}}</td>
                          </tr>
                          <tr>
                            <td>Total Amount Paid Settlement Time</td>
                            <td>{{seeRecordSettlement.totalAmountPaidWithSettlement}}</td>
                          </tr>
                          <tr>
                            <td>Reason</td>
                            <td>{{seeRecordSettlement.reason}}</td>
                          </tr>
                          <tr>
                            <td>Status</td>
                            <td>{{seeRecordSettlement.status}}</td>
                          </tr>
                          <tr v-if="seeRecordSettlement.branch_ledger">
                            <td>Payment Mode</td>
                            <td>{{seeRecordSettlement.branch_ledger.ledger.name}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p class="text-bold">Note: This is a computer‐generated document. No signature is required</p>
                    </div>
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
          </div>
          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { Printd } from 'printd'
  export default {
    name: 'VIEWPRINTSETTLEMENT',
    props: ['seeRecordSettlement', 'getCompanyRecord'],
    data () {
      return {
        cssText: `.printing {
          font-family: sans-serif;
          text-align: center;
          padding-bottom: 2rem;
  
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }
        @page {
          size: A4;
          margin: 0;
        }
        
        p {
          font-weight: bold;
        }
        table.center {
          margin-left: auto; 
          margin-right: auto;
        }
        table th, table td { border:1px solid #000; padding:0.5em; border-collapse: collapse; }`
      }
    },
    mounted () {
  
    },
    methods: {
      printSettlementReceiptView () {
        const d = new Printd()
        d.print(document.getElementById('printSettlementReceiptView'), [this.cssText])
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// SettlementPrintView.vue?129e32ca